import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const DRAW_ROUTES: RouteObject[] = [
  {
    path: 'draw',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'campaigns',
        lazy: async () => {
          const CampaignsPage = lazy(
            () => import('@/pages/draw/campaigns/CampaignsPage.tsx')
          )
          return { element: <CampaignsPage /> }
        }
      },
      {
        path: 'draws',
        lazy: async () => {
          const DrawsPage = lazy(
            () => import('@/pages/draw/draws/DrawsPage.tsx')
          )
          return { element: <DrawsPage /> }
        }
      }
    ]
  }
]

export default DRAW_ROUTES
